export const ACCOUNT_MODE = {
  DEFAULT: null,
  EXPERT: 0,
  SMART: 1,
  UNIFIED_SMART: 2,
  UNIFIED_EXPERT: 3,
};
